module.exports = __webpack_public_path__ + "img/perfectiondetail@2x.75becd9.jpg";